import React, { useContext } from 'react'

// Libs
import { Tooltip } from '@mui/material'
import { cloneDeep } from 'lodash'

// Components
import { IconSwitch } from '../../../../components/icons/IconSwitch'

// Helpers
import useToasterHelper from '../../../../helpers/ToasterHelper'

import { HandleModalContext } from '../../../../layout/mainlayout/MainLayout'

// Models
import { IRider } from '../../../../types/entryRider'
import { IRegistrationByDayInterface } from '../../../../models/registrations-by-day/registrationByDay.interface'

// Constants
import { PAYMENT_TYPE } from '../../../../types/payment'
import { MESSAGES_CONST } from '../../../../const/messages-const'
import { MODAL_CONSTS } from '../../../../const/modal-const'

interface ButtonSwitchHorseProps {
  row: IRider
  registrationsByDay: IRegistrationByDayInterface[]
  setRegistrationByDay: (state: IRegistrationByDayInterface[]) => void
  getEventRiderTeamMembers: () => Promise<void>
}

export const ButtonSwitchHorse: React.FC<ButtonSwitchHorseProps> = ({
  row,
  registrationsByDay,
  setRegistrationByDay,
  getEventRiderTeamMembers,
}) => {
  const toastFunction = useToasterHelper()
  const handleModalContext = useContext(HandleModalContext)

  return (
    <Tooltip title={<span className={'text-[12px]'}>Switch horse</span>} placement="top" arrow>
      <button
        className={'group'}
        onClick={() => {
          if (
            row.paymentType === PAYMENT_TYPE.DEFAULT &&
            row.paymentStatus === PAYMENT_TYPE.DEFAULT
          ) {
            return toastFunction.info({ message: MESSAGES_CONST.NOT_REGISTERED_YET })
          }

          handleModalContext?.handleModal(true, MODAL_CONSTS.SWITCH_HORSE, {
            rider: row,
            onSwitchHorse: async (registrationsByDayToUpdate: IRegistrationByDayInterface[]) => {
              const registrationsByDayUpdated = cloneDeep(registrationsByDay).map((item) => {
                const current = registrationsByDayToUpdate.find(
                  (registrationByDay) => registrationByDay.id === item.id
                )
                if (current) {
                  return current
                } else {
                  return item
                }
              })

              setRegistrationByDay([...registrationsByDayUpdated])
              await getEventRiderTeamMembers()
              handleModalContext?.handleModal(false, MODAL_CONSTS.SWITCH_HORSE)
            },
          })
        }}
      >
        <IconSwitch />
      </button>
    </Tooltip>
  )
}
